import type { ActionTypeEnum } from "@superblocksteam/shared";

import type { EntitiesStateWithMeta } from "core/store/utils/types";

import type { Binding, StepRunTestData } from "../../../../core/api/types";
import { Slice } from "../../utils/slice";
import {
  isApiDtoWithPb,
  type ApiDtoWithPb,
  type ExecutionResponse,
  type EnrichedExecutionResult,
} from "./types";

export { type Binding, type StepRunTestData };
export { isApiDtoWithPb, type ApiDtoWithPb };

export type ApiV2Meta = {
  applicationId?: string;
  executionResult?: ExecutionResponse;
  enrichedExecutionResult?: EnrichedExecutionResult;
  dirty?: boolean;
  saving?: boolean;
  isUpdating?: boolean;
  isDeleting?: boolean;

  needsBindingExtraction?: boolean; // API requires new bindings to be extracted
  extractingBindings?: number; // the API's bindings are currently being extracted by the saga call with this callId
  extractedBindings?: Binding[]; // API has extracted bindings
  extractedBindingsByBlock?: Record<string, Binding[]>;
  nameIteratorValue?: number;

  apiDependencies?: string[];
  cancelled?: boolean;
  cancelledByType?: CancelledByType;
  concurrentRuns?: number;
  waitingForEvaluationSince?: string;
  savingFailuresCount?: number;
  testProfile?: string; // used to general test url profile param
  editedSinceLastExecution?: boolean;
  hydratingBlocks?: Record<string, boolean>;

  // Data for single-step runs
  showTestDataForBlock?: Record<string, boolean>;
  variableBindingsByBlock?: Record<string, string[]>;
  blockBindingsByBlock?: Record<string, string[]>;
  referencedVariableBlocksByBlock?: Record<string, string[]>;
  extractingBlockBindings?: boolean;
  testDataForBlock?: Record<string, undefined | StepRunTestData>;
  cachedTestDataForBlock?: Record<string, undefined | StepRunTestData>;
  testDataEvaluationError?: Record<
    string,
    {
      fieldErrors: Record<string, string>;
      generalErrors: string[];
    }
  >;

  singleStepRuns?: Record<
    string,
    {
      loading?: boolean;
      cancelled?: boolean;
      hasRunMostRecently?: boolean;
    }
  >;
};

export enum CancelledByType {
  MANUAL = "manual",
}

export type ApiV2State = EntitiesStateWithMeta<ApiDtoWithPb, ApiV2Meta> & {
  permissions: Record<string, ActionTypeEnum[]>;
};

export default new Slice<ApiV2State>("apisV2", {
  entities: {},
  loading: {},
  errors: {},
  meta: {},
  permissions: {},
});
